import cn from 'classnames';
import type { FC } from 'react';
import { PersonalDefaultIcon60, PersonDefault, PersonIcon2 } from '@shared/assets';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';
import * as st from './styles.module.scss';

interface Props {
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  defaultVariant?: 'primary' | 'secondary';
  className?: string;
}

export const Avatar: FC<Props> = ({ src, size = 'sm', defaultVariant = 'primary', className }) => {
  const size_cn = {
    sm: st.small,
    md: st.medium,
    lg: st.large,
  }[size];

  if (!src) {
    return (
      <div className={cn(st.avatarEmpty, size_cn, className)}>
        {defaultVariant === 'primary' && size === 'sm' && <PersonDefault />}
        {defaultVariant === 'primary' && size === 'md' && <PersonalDefaultIcon60 />}
        {defaultVariant === 'secondary' && <PersonIcon2 />}
        {}
      </div>
    );
  }
  return (
    <ImageWithSkeleton
      src={src}
      className={cn(st.avatar, size_cn)}
      wrapperClassName={st.imgWrapper}
    />
  );
};
